//Implemented in HomeContiner
const componentStyles = {
    header: {
        background:
            "linear-gradient(87deg," + "#11cdef" + ",#1171ef)",
    },

};

export default componentStyles;

//maybe:  "linear-gradient(-135deg, #899FD4 0%, #A389D4 100%)"
